<template>
  <base-modal
    hide-footer
    :closeable-from-outside="false"
    :size="'lg'"
    :modal-id="'select-priviege-modal'"
    @hidden="$emit('onCloseModal')"
    @show="() => {}"
  >
    <template #modal-header>
      <div class="head-label">
        <span>Select Image</span>
      </div>
    </template>
    <b-form @submit.prevent="onSaveModalSelectImage">
      <b-row>
        <b-col cols="12" class="px-2">
          <div>
            <div class="d-flex flex-wrap justify-content-end">
              <div
                class="search-container mb-1 mb-md-0 mr-0 ml-0 ml-xl-2 ml-lg-1"
              >
                <search :on-search-input="onSetValueSearch" />
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" class="px-2 mt-2">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <b-table
                :fields="fields"
                :items="selectImageList.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                class="default-static-table no-color-head"
              >
                <template #head(image_url)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(image_url)="data">
                  <div class="d-flex justify-content-center align-item-center">
                    <img
                      :src="data.item.image_url || DefaultImg"
                      class="middle-image-column"
                    />
                  </div>
                </template>
                <template #cell(image_name)="data">
                  <div>{{ data.item.image_name }}</div>
                </template>
                <template #cell(actions)="data">
                  <b-button
                    class="btn-select-image ml-2"
                    @click="selectPrivilegeImage(data.item)"
                    :disabled="data.item.image_id == image_Id"
                  >
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      <span>{{ "Select" }}</span>
                    </div>
                  </b-button>
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty> </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12">
          <pagination-with-reorder
            entity-editable
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
        <b-col cols="12">
          <div class="mt-2">
            <div class="d-flex justify-content-center">
              <cancel-button
                class="mr-1"
                @click.native="$emit('onCloseModal')"
              />
              <save-button
                :type="'submit'"
                class="ml-1"
                :disabled="image_Id == null || image_Id == undefined"
              />
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="modal-body-container mb-1" />
    </b-form>
  </base-modal>
</template>

<script>
import BaseModal from "@/@core/components/base-modal/BaseModal.vue";
import Search from "@/views/components/search/Search.vue";
import AddButton from "@/views/components/button/AddButton.vue";
import DefaultImg from "@/assets/images/icons/no-img-square.jpg";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import useSelectImageModal from "../hooks/useSelectImageModal";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import NoInventory from "@/assets/images/artwork/folder.png";

export default {
  components: {
    BaseModal,
    Search,
    AddButton,
    PaginationWithReorder,
    CardNoItem,
  },
  props: {
    loadingOverlay: Object,
    privilegeId: { type: Number, default: 0 },
    imageId: { type: Number, default: 0 },
  },
  setup(props) {
    const {
      pagination,
      onPageChange,
      onFilterEntity,
      filters,
      ordering,
      onSetValueSearch,
      onSelectFilter,
      loading,
      fields,
      selectImageList,

      selectPrivilegeImage,
      image_Id,
      onSaveModalSelectImage,
    } = useSelectImageModal(props);

    return {
      DefaultImg,
      NoInventory,

      pagination,
      onPageChange,
      onFilterEntity,
      filters,
      ordering,
      onSetValueSearch,
      onSelectFilter,

      loading,
      fields,
      selectImageList,

      selectPrivilegeImage,
      image_Id,
      onSaveModalSelectImage,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/status.css";
@import "~@/assets/css/override-styles/v-select.css";
@import '~@/assets/css/pages/privilege/privilege-code-template/select-image-modal.css';
</style>
